import { NetworkSetup } from "../network-setup";
import { USDT_ABI } from "./usdt-abi";

const USDT_ADDRESS = "0x55d398326f99059fF775485246999027B3197955";

export const bscNetworkSetup: NetworkSetup = {
  chain: "ETH",
  contracts: {
    usdt: {
      decimals: 18,
      address: USDT_ADDRESS,
      abi: USDT_ABI,
    },
  },

  purchase: () =>
    Promise.reject("purchasing is not supported for this network"),
  stake: () => Promise.reject("staking is not supported for this network"),
  unstake: () => Promise.reject("unstaking is not supported for this network"),
};
